import React from 'react';
import { useVocabulary } from '../context/VocabularyContext';
import { ExerciseTypeSelector } from './ExerciseTypeSelector';
import { CategoriesGrid } from './CategoriesGrid';
import { WordPoolsGrid } from './WordPoolsGrid';
import { SentenceCategoriesGrid } from './SentenceCategoriesGrid';
import { SentenceSubcategoriesGrid } from './SentenceSubcategoriesGrid';

export function NavigationContainer() {
  const { state } = useVocabulary();
  const { currentView } = state;

  const renderCurrentView = () => {
    switch (currentView) {
      case 'exercise-type-selector':
        return <ExerciseTypeSelector />;
      case 'categories':
        return <CategoriesGrid />;
      case 'word-pools':
        return <WordPoolsGrid />;
      case 'sentence-categories':
        return <SentenceCategoriesGrid />;
      case 'sentence-subcategories':
        return <SentenceSubcategoriesGrid />;
      default:
        return <ExerciseTypeSelector />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main content */}
      <div className="container mx-auto px-4 py-6">
        {renderCurrentView()}
      </div>
    </div>
  );
} 